export default __webpack_public_path__ + "static/hq21-e44bdd7a943f02d728ccb939640f5ab7.jpg";